import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TableComponent } from '../table/components/table/table.component';
import { TableColumnDirective } from '../table/directives/column.directive';
import { ClientPortalDetailsUrlPipe } from '../../shared/pipes/client-portal-details-url.pipe';
import { TableColumn } from '../../shared/models/table-column.model';

@Component({
  selector: 'app-client-portal-drilldown-table',
  templateUrl: './client-portal-drilldown-table.component.html',
  styleUrls: ['./client-portal-drilldown-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TableComponent, TableColumnDirective, ReactiveFormsModule, InputTextModule, ButtonModule, ClientPortalDetailsUrlPipe],
})
export class ClientPortalDrilldownTableComponent {
  @Input() columns!: TableColumn[];
  @Input() rows!: any[] | null;
  @Input() searchTerm!: FormControl;

  pageSizeOptions: number[] = [10, 25, 50, 100];
}
